import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";

export class FreespinsRetriggered extends Decision {
    public evaluate() {
        let record = gameState.getCurrentGame().getCurrentRecord();

        if (!(record instanceof FreespinRecord) && record.lastChild) {
            record = record.parent;
        }

        return record instanceof FreespinRecord && record.getFreespinsWon() > 0 ? Exit.True : Exit.False;
    }
}
